import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('integration/sap/tasks?page=' + page, {params});
    },
    task_log(id) {
        return Service().get('integration/sap/tasks/log/'+id);
    },
    task_log_by_mcr(mcr_code) {
        return Service().get('integration/sap/tasks/log-by-mcr/'+mcr_code);
    },
    synchron(id) {
        return Service().post('integration/sap/tasks/'+id);
    },
    synchronUpdateStock(id) {
        return Service().post('integration/sap/tasks-update-stock/'+id);
    },
    manualSyncTask(body) {
        return Service().post('integration/sap/manual-execute', body);
    }
}